export default __webpack_public_path__ + "static/media/OchurchillOpen.770df4f7.jpg";